import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { useAppState } from "@/modules/app/useAppContext";

const IntercomChatBoot = ({ tenant, env }: { tenant: string; env: string }) => {
  const { boot, update } = useIntercom();
  const { loggedinUser: userData, sidebarExpanded } = useAppState(); // Fetch user data

  useEffect(() => {
    boot({
      customLauncherSelector: "#chat-with-us-button",
      hideDefaultLauncher: true,
      alignment: "left",
    });
  }, [boot]);

  useEffect(() => {
    update({ horizontalPadding: sidebarExpanded ? 260 : 80 });
  }, [sidebarExpanded, update]);

  useEffect(() => {
    if (userData) {
      const userName = userData["first_name"] + " " + userData["last_name"]; // user's first name
      const userEmail = userData["email"]; // user's email address
      const userId = userData["uuid"];
      const bootProps = {
        userId: userId,
        email: userEmail,
        name: userName,
        company: {
          companyId: env + "+" + tenant,
          name: tenant,
        },
      };
      update(bootProps);
    }
  }, [userData, update, tenant, env]);

  return <></>;
};

export default IntercomChatBoot;
